import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "voice-panel"
};
const _hoisted_2 = { class: "voice-panel__header" };
const _hoisted_3 = {
    key: 0,
    class: "voice-panel__title"
};
import { computed, onMounted, ref } from "vue";
import CallSessionThread from "@/components/voice_ai/CallSessionThread.vue";
import VoiceCallTriggerCard from "@/components/voice_ai/VoiceCallTriggerCard.vue";
import { offeredTemplates, } from "@/components/voice_ai/anchors";
import { voiceAiService } from "@/services/voiceAiService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoiceCallPanel',
    props: {
        anchor: {},
        surface: {},
        title: { default: "" },
        config: { default: undefined },
        templates: { default: undefined },
        calls: { default: undefined },
        callsLoading: { type: Boolean, default: false },
        patient: { default: null },
        dense: { type: Boolean, default: false },
        triggerLabel: { default: "Voice AI Call" },
        triggerVariant: { default: "elevated" }
    },
    emits: ["call-triggered", "calls-changed"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const threadRef = ref(null);
        const fetchedConfig = ref(null);
        const fetchedTemplates = ref(null);
        const resolvedConfig = computed(() => (props.config !== undefined ? props.config : fetchedConfig.value));
        const resolvedTemplates = computed(() => (props.templates !== undefined ? props.templates : fetchedTemplates.value) || []);
        const showTrigger = computed(() => !!resolvedConfig.value?.isEnabled && offeredTemplates(resolvedTemplates.value, props.surface).length > 0);
        // Past calls stay visible after a tenant turns voice off; in self-fetch mode the thread owns the
        // list, so it renders whenever voice is on.
        const showThread = computed(() => showTrigger.value || (props.calls === undefined ? !!resolvedConfig.value?.isEnabled : props.calls.length > 0));
        onMounted(async () => {
            try {
                if (props.config === undefined)
                    fetchedConfig.value = await voiceAiService.getConfig();
                if (props.templates === undefined)
                    fetchedTemplates.value = await voiceAiService.listTemplates();
            }
            catch {
                // Non-critical: the panel stays hidden when config cannot be loaded.
            }
        });
        function refresh() {
            return threadRef.value?.refresh();
        }
        function onCallTriggered(session) {
            if (props.calls === undefined)
                refresh();
            emit("call-triggered", session);
        }
        __expose({ refresh });
        return (_ctx, _cache) => {
            return (showTrigger.value || showThread.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (__props.title)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1))
                            : _createCommentVNode("", true),
                        (showTrigger.value)
                            ? (_openBlock(), _createBlock(VoiceCallTriggerCard, {
                                key: 1,
                                anchor: __props.anchor,
                                surface: __props.surface,
                                config: resolvedConfig.value ?? undefined,
                                templates: resolvedTemplates.value,
                                patient: __props.patient ?? undefined,
                                label: __props.triggerLabel,
                                "button-variant": __props.triggerVariant,
                                onCallTriggered: onCallTriggered
                            }, null, 8, ["anchor", "surface", "config", "templates", "patient", "label", "button-variant"]))
                            : _createCommentVNode("", true)
                    ]),
                    (showThread.value)
                        ? (_openBlock(), _createBlock(CallSessionThread, {
                            key: 0,
                            ref_key: "threadRef",
                            ref: threadRef,
                            anchor: __props.anchor,
                            calls: __props.calls,
                            "calls-loading": __props.callsLoading,
                            "tenant-config": resolvedConfig.value ?? {},
                            dense: __props.dense,
                            class: _normalizeClass(__props.dense ? 'mt-1' : 'mt-2'),
                            onCallsChanged: _cache[0] || (_cache[0] = ($event) => (emit('calls-changed', $event)))
                        }, null, 8, ["anchor", "calls", "calls-loading", "tenant-config", "dense", "class"]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
